





























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { ServerResult } from '@/core/http/server_result';
import { QueryBuilder } from '@/core/uql';

@Component
export default class ProductVariantSelect extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>
  $q!: (queryName: string) => QueryBuilder;

  @Prop() value!: any;
  // @Prop({ type: String }) schema!: string;
  // @Prop({ type: Array }) data!: any[];
  // @Prop({ type: String }) keyField!: string;
  // @Prop({ type: String }) labelField!: string;
  @Prop({ type: String }) relField!: string;
  @Prop({ type: String }) relFilter!: string;

  @Prop({ type: String }) position!: string;
  @Prop({ type: Boolean }) multiple!: boolean;

  @Prop({ type: String }) placeholder!: string;
  @Prop({ type: String }) clearable!: boolean;

  localValue: any = null
  selectdItemLabel: any = '';
  dropdownActive = false;

  items: any[] = [];
  itemsForDisplay: any[] = [];

  searchText: string = '';

  public created() {
    // 
  }

  public mounted() {
    this.selectdItemLabel = this.placeholder;

    // if (this.schema) {
      this.loadData();
    // } else {
    //   this.items = this.data;
    //   this.onValueChange(this.value);
    //   this.updateDisplayList();
    // }
  }

  public loadData() {
    const QNAME = `SELECT_COMBOBOX_LIST_PRODUCT_VARIANTS`;
    const relFilter =
      this.relFilter != null && this.relFilter !== "" ? this.relFilter : null;

    if (this.relField && !relFilter) {
      if (process.env.NODE_ENV === "development") {
        console.debug(
          "[ProductVariantSelect.loadData] skip: empty relFilter",
          { relField: this.relField },
        );
      }
      this.items = [];
      this.onValueChange(
        this.multiple && !Array.isArray(this.value) ? [this.value] : this.value,
      );
      this.updateDisplayList();
      return;
    }

    this.$db([
      this.$q(QNAME)
      .select()
      .fileds({
          id: `product_containers.id`,
          label: { "$concat": [`products.name`, {"$": " / "}, `product_containers.name` ] }
      })
      .innerJoin('products', (_: any) => {
        return _.eq('products.id', 'product_containers.product_id');
      })
      .order((_: any) => {
          return [
            _.asc([`products.name`]),
            _.asc([`product_containers.name`]),
          ];
      })
      .from('product_containers')
      .where((_: any) => {
        return _.and([
          { $null: [ 'products.archived_at' ] },
          { $null: [ 'product_containers.archived_at' ] },
          ...(this.relField && relFilter
            ? [ _.eq(`product_containers.${this.relField}`, _.const(relFilter)) ]
            : [])

        ])
      })
      .limit(1000),
    ]).then(((result: ServerResult) => {
      this.items = result.getOperation(QNAME).getContent().documents;

      if(this.multiple && !Array.isArray(this.value)) {
        this.onValueChange([this.value]);
      } else {
        this.onValueChange(this.value);
      }
      this.updateDisplayList()
    }));
  }

  @Watch('value')
  onValueChange(newVal: any) {
    // console.log(newVal);
    this.localValue = newVal;

    if (this.localValue) {
      if(Array.isArray(this.localValue)) {
        const selectdItems = this.items.filter((item) => this.localValue.includes(item.id));

        if (selectdItems.length > 0) {
          this.selectdItemLabel = selectdItems.map(item => item.label).join(', ');
        } else {
          this.selectdItemLabel = ''
        }

      } else {
        const selectdItem = this.items.find((item) => item.id == this.localValue);

        if (selectdItem) {
          this.selectdItemLabel = selectdItem.label;
        } else {
          this.selectdItemLabel = ''
        }
      }
    } else {
      this.selectdItemLabel = ''
    }
  }

  @Watch('relFilter')
  onRelFilterChange(newVal: any) {
    console.log('onRelFilterChange');
    this.updateValue(null);
    this.loadData();
  }

  updateValue(value: any) {
    this.onValueChange(value);
    this.$emit('input', value);

    if(Array.isArray(this.localValue)) {
        const selectdItems = this.items.filter((item) => this.localValue.includes(item.id));

        this.$emit('input-object', selectdItems);

      } else {
        const selectdItem = this.items.find((item) => item.id == this.localValue);

        this.$emit('input-object', selectdItem);
      }
  }

  clear() {
    this.updateValue(null)
  }

  activeChange($event: any) {
    this.dropdownActive = $event;
    const width = this.$el.clientWidth;
    // @ts-ignore
    this.$children[0].$refs.dropdownMenu.children[0].style.width = width + 'px';
    // @ts-ignore
    this.$children[0].$refs.dropdownMenu.children[0].children[0].style.width = (width - 25) + 'px';
    console.log('this.dropdownActive', this.dropdownActive, this.$refs.searchInput);
    if (this.dropdownActive) {
      (this.$refs.searchInput as any).focus()
    }
  }

  @Watch('searchText')
  updateDisplayList() {
    this.$set(this, 'itemsForDisplay', (this.items || []).filter((item: any) => {
      return item.label.toLowerCase().includes(this.searchText);
    }))
  }

  // search($event) {
  //   throttle
  // }
}
